/**
 * @desc 邮件帐号保存
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(body: defs.mail.MailAccountRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/mailAccount/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
